module.exports = __webpack_public_path__ + "static/3-0cc2a0dd3b0d25d7749aad8ee640aaf8.jpg";